import React from 'react'
import { Heading, Stack, FormField } from '@/components/lib'

const Name = ({ trial, fields, data, updateData }) => {
  return (
    <Stack gap={5}>
      <Stack gap={5}>
        <Heading as='h3' size='md'>Name and description</Heading>

        <Stack spacing={5}>
          {fields.map(field =>
            <FormField key={field.label} placeholder={field.placeholder} required={field.required} label={field.label} type={field.type} value={data[field.key]} onChange={e => updateData({ [field.key]: e.target.value })} />
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Name
